import { api } from "../AxiosInstance";

export function getCurrentUserApi() {
  return api().get("/api/Auth/GetCurrentUserInfo");
}

export function LoginApi(userDetails) {
  return api().post("/api/Auth/SignIn", userDetails);
}

export function checkUserNameApi(params) {
  return api().get("/api/User/CheckUserName", { params });
}

export function loginUserByKeyApi(params) {
  return api().get("/api/Auth/CheckLoginKey", { params });
}

export function getHelpicalTokenApi(payload) {
  return api().post("/api/Auth/Helpical", payload);
}